import { merge } from 'lodash';
import config from '../../config';
import configDev from '../../config/index.development';

export default {
  getConfig(name) {
    const configTenant = config[name];
    if (process.env.NODE_ENV === 'development') {
      merge(configTenant, configDev[name]);
    }

    return configTenant || config.default;
  },
};
